import React from 'react';
import {API_URL, HTTP_REQUEST_HEADER} from 'constants/api';
import {instanceDyChoose, instanceDyEngagement, instanceGusaBackend} from 'libs/api';
import {POST_MESSAGE_TYPES, postMessage} from 'libs/postMessage/postMessage';
import DynamicRemoteApp from '../../components/dynamicRemoteApp/dynamicRemoteApp';
import {Location} from 'history';
import {Loader} from './loader/loader';
import {getVisitorId} from 'libs/user/getVisitorId';
import {cookieStore} from 'libs/storage/storage';
import {OAUTH_COOKIE_KEY} from 'constants/app';
import flags from 'constants/flags/flags';
import {useStore} from 'react-redux';
import {useCookies} from 'libs/cookie/useCookies';
import {getStoreId} from 'constants/store';

type PropsType = {
    location: Location;
};

/**
 * Profile Router
 * @returns {React.ReactNode} Return current route
 */
export const Account: React.FC<PropsType> = ({location}) => {
    const store = useStore();
    const [cookies] = useCookies();

    return (
        <DynamicRemoteApp
            remoteAppInfo={{
                url: `${process.env.ACCOUNT_URI}remoteEntry.js`,
                scope: 'Account',
                module: './Pages',
            }}
            skeleton={<Loader />}
            props={{
                apiConfig: {
                    API_URL,
                    HTTP_REQUEST_HEADER,
                    STORE_ID: getStoreId(cookies),
                    instanceGusaBackend,
                    instanceDyChoose,
                    instanceDyEngagement,
                    logOut: () => {
                        postMessage({type: POST_MESSAGE_TYPES.LOG_OUT});
                        cookieStore.remove(OAUTH_COOKIE_KEY);
                    },
                    flags: {
                        showOrderButtons: flags.showOrderButtons.isEnabled(),
                    },
                },
                hostStore: store,
                location,
                path: '/customer/account',
                platform: 'app',
                isUhc: false,
                visitorId: getVisitorId(),
            }}
        />
    );
};
